/**
 * DataProvider
 *
 * @module DataProvider
 */
(function DataProvider(){

    /**
     * Provides markerdata
     * @method markerByAjax
     * @param {string} nodeIdentifier
     * @param {string} workspace
     * @param {function} success
     * @param {function} error (optional)
     * @constructor
     */
    function markerByAjax(nodeIdentifier, workspace, success, error) {

        var that = this;

        /**
         * Call error callback or log error if possible
         * @method callError
         * @param {mixed} errorParam
         */
        this.callError = function(errorParam) {
            if(typeof error === 'function') {
                error(errorParam);
            }else if(typeof window.console != 'undefined' && typeof window.console.warn != 'undefined') {
                console.warn("Error fetching data for " + nodeIdentifier + " in workspace " + workspace);
            }
        };

        var request = new XMLHttpRequest();
        request.open('GET', '/techdivision-map/' + nodeIdentifier + '/' + workspace, true);
        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                success(request.responseText, request);
            } else {
                that.callError(request);
            }
        };
        request.onerror = function(err) {
            that.callError(err);
        };
        request.send();
    }

    /**
     * Gets the data for markers from the dom
     * @method markerFromDom
     * @param {object} dom A parent dom element of the markers
     * @returns {Array} Returning the marker data
     * @constructor
     */
    function markerFromDom(dom) {
        var markersDom = dom.querySelectorAll('[data-tdmap="marker"]');
        var markers = [];
        Array.prototype.forEach.call(markersDom, function(markerDom, i){
            var latitude = markerDom.getAttribute('data-tdmap-latitude');
            var longitude = markerDom.getAttribute('data-tdmap-longitude');
            // only if latitude and longitude are valid
            if(latitude.length > 0 && !isNaN(latitude) && longitude.length > 0 && !isNaN(longitude)) {
                markers.push({
                    latitude: parseFloat(latitude),
                    longitude: parseFloat(longitude),
                    content: markerDom.querySelectorAll('[data-tdmap-marker="content"]')[0]['innerHTML']
                });
            }
            // if rendering is not in backend remove the marker's dom
            if(TechDivisionMap.Context.isFrontend()) {
                markerDom.parentNode.removeChild(markerDom);
            }
        });
        return markers;
    }

    if(typeof window.TechDivisionMap === 'undefined') {
        window.TechDivisionMap = {};
    }

    window.TechDivisionMap.DataProvider = {
        markerByAjax: markerByAjax,
        markerFromDom: markerFromDom
    };

})();